import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from 'react';
import SvgXIcon from '../svg/XIcon';

/**
 * Component to create help text boxes in the interface
 * @param {*} ref - A "useRef" object in the parent passed down to allow the helptext to be opened and closed
 * @param {function} toggleFunction - The function that will be triggered when the helptext is opened and closed. This function should be a toggle to update the helpicon toggled state
 * @param {*} message - The content to put inside the helptext
 */

const InlineWarningText = forwardRef((props, ref) => {
  const { toggleFunction, message } = props;
  const [showHelpText, setShowHelpText] = useState(false);

  useImperativeHandle(ref, () => ({
    toggleHelpText() {
      setShowHelpText(!showHelpText);
    },
  }));

  useEffect(() => {
    if (toggleFunction) {
      toggleFunction(showHelpText);
    }
  }, [toggleFunction, showHelpText]);
  function toggleHelpText() {
    setShowHelpText(!showHelpText);
  }

  if (showHelpText) {
    return (
      <div className="inline-alert-text__container inline-alert-text__container--warning">
        <div className="inline-alert-text__help-message text-bold">
          {message}
        </div>
        <div className="inline-alert-text__close-icon inline-alert-text__close-icon--warning">
          <SvgXIcon
            onClick={toggleHelpText}
            className="cursor-pointer"
            data-test="close-icon"
          />
        </div>
      </div>
    );
  } else {
    return '';
  }
});

export default InlineWarningText;
